/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
  preEditorData: null,

};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.FieldPreEditorAction.REQUEST_PRE_EDITOR_DATA:
     
      return {
        ...state
      };
    case actions.FieldPreEditorAction.PRE_EDITOR_DATA_RECEIVED:
   
      return {
        ...state,
        preEditorData: action.data.Response,
      
        // userid: action.payload.user_ID,
        // projectid: action.payload.project_ID,
      };


    default:
      return state;
  }
};

export default reducer;
